import React from 'react';
import { C } from '../../shared/design-tokens.js';

export const CONTROL_INPUT: React.CSSProperties = {
  width: '100%',
  padding: '10px 14px',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 8,
  color: '#fff',
  fontSize: 14,
  fontFamily: 'Montserrat, Arial, sans-serif',
  outline: 'none',
};

export const MUTED_LABEL: React.CSSProperties = {
  fontSize: 11,
  color: C.textMuted,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
  display: 'block',
};

export function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}
